import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { PaddedContainer } from '../PaddedContainer';

interface PageWrapperProps {
    children: React.ReactNode[];
    noPadding?: boolean;
}

const PageWrapper = ({ children, noPadding }: PageWrapperProps) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    let padding = isDesktop ? 4 : 2;
    padding = noPadding ? 0 : padding;

    return (
        <PaddedContainer padding={padding}>
            {children}
        </PaddedContainer>
    );
};

export default PageWrapper;
